import { useRef,useState} from "react";


export function Contact(){
    const email = useRef(null);
    const [isValidEmail, setIsValidEmail] = useState(true);
  
    const handleForm = (event) => {
      event.preventDefault();
      validateEmail(email.current.value);
    };
  
    const validateEmail = (inputEmail) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isValid = emailPattern.test(inputEmail);
      setIsValidEmail(isValid);
    };
    return <div className="box-contact">
        <div className="container">
        <div className="content-box">
            <h1>Get early access today</h1>
            <p>It only takes a minute to sign up and our free starter tier is extremely generous. If you have any 
    questions, our support team would be happy to help you.</p>
            {/* Formulario de contacto */}
            <form onSubmit={handleForm}>
                <input  type="text" className="email" ref={email} placeholder="email@exemple.com" />
                <button type="submit">Get Started For Free</button>
                {!isValidEmail && <p style={{ color: 'red' }}>Please enter a valid email address.</p>}
        </form>
        </div>
        </div>
    </div>
}
export default Contact;